function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoolingTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M25.1,27.46A21.74,21.74,0,1,0,46.84,49.2,21.76,21.76,0,0,0,25.1,27.46Zm0,41.34A19.6,19.6,0,1,1,44.7,49.2,19.63,19.63,0,0,1,25.1,68.8Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,49.2a5,5,0,1,0-5,5A5,5,0,0,0,30.1,49.2Zm-5,2.85A2.86,2.86,0,1,1,28,49.2,2.86,2.86,0,0,1,25.1,52.05Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32,38.83a5.73,5.73,0,0,1,2.56,4.06H25a7.78,7.78,0,0,0-3.41-5.77A8.31,8.31,0,0,0,15,35.31l.47,2.08A6.3,6.3,0,0,1,20.32,38.83Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.35,59.7a5.7,5.7,0,0,1-2.53-4.08H25.67a7.81,7.81,0,0,0,3.38,5.79,8.92,8.92,0,0,0,5.44,2,5.51,5.51,0,0,0,1.12-.1l-.47-2.09A6.35,6.35,0,0,1,30.35,59.7Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.59,48.08l1.11-1.84A7.87,7.87,0,0,0,13,46.19a8.41,8.41,0,0,0-4.94,4.69l2,.67a6.28,6.28,0,0,1,3.71-3.37A5.72,5.72,0,0,1,18.59,48.08Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,50.42l-1.11,1.83a6.77,6.77,0,0,0,3.3.77,9.31,9.31,0,0,0,3.4-.67,8.39,8.39,0,0,0,5-4.66l-2-.68a6.29,6.29,0,0,1-3.73,3.34A5.75,5.75,0,0,1,32,50.42Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.55,58.45a8.39,8.39,0,0,0,1.62,6.62l1.59-1.43a6.32,6.32,0,0,1-1.09-4.9A5.71,5.71,0,0,1,21,54.52l-1-1.87A7.8,7.8,0,0,0,16.55,58.45Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.11,40.1a8.38,8.38,0,0,0-1.58-6.63L30.94,34.9a6.3,6.3,0,0,1,1,4.9A5.76,5.76,0,0,1,29.67,44l1,1.88A7.8,7.8,0,0,0,34.11,40.1Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.87,17.17A26.17,26.17,0,0,1,39.1,20.59l1-1.87A28.72,28.72,0,0,0,25.82,15c-11.65.24-16.54,6.25-16.74,6.5l1.67,1.34C10.8,22.81,15.29,17.39,25.87,17.17Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.51,28.29c8-.17,12.76-3,15.07-4.89l-2.4,6.19,2,.77,4.38-11.27-11.24-1-.19,2.13,7.09.63C73,22.1,68.44,26,59.47,26.15a26,26,0,0,1-16.11-5.31L42,22.48a28,28,0,0,0,17,5.81Zm16-7.32-.07.18-.26-.21Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,38.08l7.11.22c-1.16,1.32-5.46,5.44-14.4,6.15a25.34,25.34,0,0,1-7.55-.55L51.69,46a27.89,27.89,0,0,0,6.07.68c.71,0,1.42,0,2.13-.08,7.93-.64,12.55-3.76,14.75-5.77l-2,6.32,2,.65,3.71-11.5-11.28-.35Zm8.37.44-.27-.19h.33Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.59,56l7.12-.06c-1.11,1.37-5.24,5.65-14.15,6.72a25.58,25.58,0,0,1-10.94-1.11l-.66,2A28.17,28.17,0,0,0,56.61,65a26.3,26.3,0,0,0,3.2-.19c7.9-.94,12.4-4.25,14.52-6.34l-1.79,6.39,2.07.58,3.24-11.65-11.28.1Zm8.39.11-.28-.18H75Z",
    style: {
      fill: "currentColor",
      stroke: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolingTower);
export default __webpack_public_path__ + "static/media/cooling_tower.6cb96fb8b6b8672c58b79e31f1f731d6.svg";
export { ForwardRef as ReactComponent };